import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import { Spinner } from "@blueprintjs/core";
import posed from "react-pose";
import { ScreenHeader } from "../Layout";
import { version } from "../../../../package.json";
import logoHeader from "../Layout/assets/images/logoHeader.png";
import logoStyleflasher from "../Layout/assets/images/styleflasher.png";
import logoSchuler from "../Layout/assets/images/schulerdesign.png";

const PoseOverlay = posed.div({
  open: {
    delayChildren: 250,
    staggerChildren: 50
  },
  closed: { delay: 500 }
});

const PoseItem = posed.div({
  open: { x: 0, opacity: 1 },
  closed: { x: 100, opacity: 0 }
});

class Settings extends PureComponent {
  static propTypes = {
    database: PropTypes.object.isRequired,
    onRefreshDatabase: PropTypes.func,
    onResetStore: PropTypes.func
  };

  static defaultProps = {
    database: null,
    onRefreshDatabase: () => {},
    onResetStore: () => {}
  };

  state = {
    isOpen: false
  };

  componentDidMount() {
    this.setState({ isOpen: true });
  }

  resetSettings = () => {
    this.props.onResetStore();
    this.props.onRefreshDatabase();
  };

  renderDatabaseUpdate = () => {
    if (this.props.database.isLoading) {
      return (
        <span>
          <Spinner size={25} intent="danger" />
        </span>
      );
    }

    return (
      <a
        href="#refresh-database"
        role="button"
        onClick={event => {
          event.preventDefault();
          this.props.onRefreshDatabase();
        }}
      >
        <i className="icon-refresh" />
        {this.props.t("settings:refresh_database")}
      </a>
    );
  };

  renderButtonLink = props => {
    return (
      <PoseItem key={props.id} className="settings-link-item menu-list-item">
        <a
          className="link-wrap"
          href={"#" + props.id}
          role="menuitem"
          onClick={e => {
            e.preventDefault();

            if (props.onClick) {
              props.onClick();
            } else {
              window.open(props.url, "_blank");
            }
          }}
        >
          <span>{props.title}</span>
          <i className={props.icon} />
        </a>
      </PoseItem>
    );
  };

  render() {
    const { t } = this.props;

    return (
      <div className="screen-container screen-settings">
        <ScreenHeader title="Settings" />
        <div className="sub-header">
          <div className="section logo">
            <img src={logoHeader} alt="HWK Skiwax" />
          </div>

          <div className="section large">
            {t("settings:app_name")}
            <span>
              {t("settings:app_version")}: {version}
            </span>
          </div>

          <div className="section">
            {t("settings:db_version")}
            <span>{this.props.database.datetime}</span>
            <span className="action">{this.renderDatabaseUpdate()}</span>
          </div>

          <div className="section">
            {t("common:developed_by")}
            <span className="logo">
              <a
                href="#styleflasher"
                title="styleflasher.new media - Die Internet und App Agentur in Tirol / Österreich"
                role="button"
                onClick={event => {
                  event.preventDefault();
                  window.open("http://styleflasher.at", "_blank");
                }}
              >
                <img
                  className="styleflasher"
                  src={logoStyleflasher}
                  alt="styleflasher_"
                />
              </a>
            </span>
          </div>

          <div className="section">
            {t("common:in_cooperation_with")}
            <span className="logo">
              <a
                href="#schulerdesign"
                role="button"
                onClick={event => {
                  event.preventDefault();
                  window.open("http://www.hs-mediadesign.com", "_blank");
                }}
              >
                <img src={logoSchuler} alt="Schulerdesign" />
              </a>
            </span>
          </div>
        </div>

        <div className="content">
          <PoseOverlay
            className="settings-links menu-list-container"
            pose={this.state.isOpen ? "open" : "closed"}
          >
            {this.renderButtonLink({
              id: "impressum",
              title: t("settings:button_impressum"),
              icon: "icon-link",
              url: "https://www.hwk-skiwachs.de/impressum"
            })}
            {this.renderButtonLink({
              id: "privacy",
              title: t("settings:button_privacy"),
              icon: "icon-link",
              url: "https://www.hwk-skiwachs.de/datenschutz"
            })}
            {this.renderButtonLink({
              id: "website",
              title: t("settings:button_website"),
              icon: "icon-link",
              url: "https://www.hwk-skiwachs.de"
            })}
            {this.renderButtonLink({
              id: "reset-settings",
              title: t("settings:button_reset_settings"),
              icon: "icon-warning",
              onClick: () => {
                this.resetSettings();
              }
            })}
          </PoseOverlay>
        </div>
      </div>
    );
  }
}

export default withNamespaces(["settings", "common"], { wait: true })(Settings);
